import styles from './JumbotronTitle.module.scss';

const JumbotronTitle: React.FC<Required<React.PropsWithChildren>> = ({
  children,
}) => <h2 className={styles.title}>{children}</h2>;

export default JumbotronTitle;
